import { Link, useNavigate } from "react-router-dom";
import { AlertTriangle, ArrowRight, Home, Mail } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-blue-950 to-slate-950 px-6 py-12">
      {/* Glow */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 left-1/2 h-80 w-80 -translate-x-1/2 rounded-full bg-blue-500/20 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-80 w-80 rounded-full bg-red-500/10 blur-3xl" />
      </div>

      <main className="relative mx-auto flex min-h-[75vh] max-w-2xl items-center justify-center">
        <div className="w-full rounded-3xl border border-white/10 bg-white/5 p-8 text-center shadow-xl backdrop-blur">
          <div className="mx-auto inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-white/80">
            <AlertTriangle className="h-4 w-4 text-amber-300" />
            Error 404
          </div>

          <h1 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Página no encontrada
          </h1>

          <p className="mx-auto mt-3 max-w-xl text-sm text-white/70 sm:text-base">
            La URL que intentaste abrir no existe o fue movida. Podés volver al inicio o
            contactarnos si necesitás ayuda.
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => navigate("/")}
              className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-white px-5 py-3 text-sm font-semibold text-slate-900 hover:bg-white/90 sm:w-auto"
            >
              <Home className="h-4 w-4" />
              Volver al inicio
              <ArrowRight className="h-4 w-4" />
            </button>

            <Link
              to="/servicios"
              className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white hover:bg-white/10 sm:w-auto"
            >
              Ver servicios <ArrowRight className="h-4 w-4" />
            </Link>

            <a
              href="mailto:info@feapi.com.ar?subject=Soporte%20FEAPI%20-%20Error%20404"
              className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white hover:bg-white/10 sm:w-auto"
            >
              <Mail className="h-4 w-4" />
              Contactar soporte
            </a>
          </div>

          <div className="mt-8 border-t border-white/10 pt-6 text-xs text-white/50">
            FEAPI • {new Date().getFullYear()}
          </div>
        </div>
      </main>
    </div>
  );
}
